import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { Option } from '../../models/common.models';
import {
  AddWarehouseManagementSystem,
  WarehouseManagementSystem,
  WmsResponse,
} from '../../models/warehouse-management-system.models';
import { WarehouseService } from '../warehouse/warehouse.service';

@Injectable({
  providedIn: 'root',
})
export class WarehouseManagementSystemService {
  http = inject(HttpClient);

  warehouseService = inject(WarehouseService);

  warehouseManagementSystems$ = this.http
    .get<WmsResponse[]>('wms')
    .pipe(
      map((response: WmsResponse[]) =>
        response.map((r) => this.getWarehouseManagementSystemsFromResponse(r)),
      ),
    );

  warehouseManagementSystems = toSignal(this.warehouseManagementSystems$, {
    initialValue: [],
  });

  warehouseManagementSystemOptions = computed<Option[]>(() => {
    const uniqueWmsCodes = this.warehouseService.uniqueWmsCodes();

    return this.warehouseManagementSystems()
      .filter((system) => uniqueWmsCodes.includes(system.code))
      .map((system) => {
        return {
          label: system.name,
          value: system.code,
        };
      });
  });

  addWms = (body: AddWarehouseManagementSystem) => this.http.post('wms', body);

  getWarehouseManagementSystemsFromResponse(
    response: WmsResponse,
  ): WarehouseManagementSystem {
    return {
      code: response.code,
      name: response.name,
      created: new Date(response.created_on),
    };
  }
}
